import { render } from "./Logo.vue?vue&type=template&id=c657894c&scoped=true&bindings={\"name\":\"props\",\"link\":\"props\",\"alt\":\"props\"}"
import script from "./Logo.vue?vue&type=script&lang=js"
export * from "./Logo.vue?vue&type=script&lang=js"

import "./Logo.vue?vue&type=style&index=0&id=c657894c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c657894c"

export default script